import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../firebase';

const Shop = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState(null); // null = loading

  useEffect(() => {
    const ref = doc(firestore, 'bizarre', 'products');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const arr = snap.exists() ? snap.data()?.products || [] : [];
        setProducts(arr);
      },
      (err) => {
        console.error('Products snapshot error:', err);
        setProducts([]);
      } 
    );
    return () => unsub();
  }, []);

  const sorted = useMemo(() => {
    const arr = Array.isArray(products) ? products.slice() : [];
    // newest first: highest order first
    arr.sort((a, b) => (Number(b?.order || 0) - Number(a?.order || 0)) || String(a?.name || '').localeCompare(String(b?.name || '')));
    // filter optional flags
    return arr.filter(p => p?.isActive !== false);
  }, [products]);

  const fmtUSD = (cents) => {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '-';
    return (n / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  };

  const openProduct = (id) => navigate(`/product/${id}`);

  return (
    <div className="sf-shop">
      <h1 className="sf-title">Shop</h1>

      {products === null ? (
        <div className="sf-grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="sf-card skeleton" />
          ))}
        </div>
      ) : sorted.length ? (
        <div className="sf-grid">
          {sorted.map((p) => {
            const cover = Array.isArray(p.images) && p.images.length ? p.images[0] : '';
            return (
              <div key={p.id} className="sf-card" onClick={() => openProduct(p.id)} role="button" tabIndex={0}
                   onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openProduct(p.id)}>
                <div className="sf-card-imgwrap">
                  {cover ? <img src={cover} alt={p.name} /> : <div className="sf-card-ph" />}
                </div>
                <div className="sf-card-body">
                  <div className="sf-card-name" title={p.name}>{p.name}</div>
                  <div className="sf-card-price">{fmtUSD(p.priceCents)}</div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="sf-empty">No products released yet.</p>
      )}

      <style>{`
:root{
  --sf-gold:#fdca05;
  --sf-gold-20:#fdca05;
  --sf-gold-12:rgba(245,198,93,.12);
  --sf-card:#0b0b0b;
  --sf-bd:rgba(255,255,255,.10);
  --sf-bd-2:rgba(255,255,255,.18);
}
    body {
  font-family: 'CustomFont', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #000;
  color: #fff;
}
.sf-shop{
  background:#000; color:#fff;
  min-height:calc(100vh - 120px);
  max-width:1200px; margin:18px auto 60px; padding:0 16px;
}
.sf-title{
  font-size:2.0rem; font-weight:900; letter-spacing:.02em;
  color:#fff; text-shadow:0 0 18px var(--sf-gold-12);
  margin:6px 0 14px;
}

/* grid */
.sf-grid{
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(220px,1fr));
  gap:14px;
}

.social-links a {
  color: #fdca05;
  text-decoration: none;
}

/* card */
.sf-card{
  background:var(--sf-card);
  border:1px solid var(--sf-bd);
  border-radius:14px;
  overflow:hidden;
  cursor:pointer;
  transition:transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  box-shadow:0 6px 18px rgba(0,0,0,.28);
  outline:none;
}
.sf-card:hover{ transform:translateY(-3px); border-color:var(--sf-gold-12); box-shadow:0 10px 24px rgba(245,198,93,.12); }
.sf-card:focus-visible{ border-color:var(--sf-gold); }

.sf-card-imgwrap{ aspect-ratio:1/1; background:#111; }
.sf-card-imgwrap img{ width:100%; height:100%; object-fit:cover; display:block; }
.sf-card-ph{ width:100%; height:100%; background:linear-gradient(135deg,#151515,#1b1b1b); }

.sf-card-body{ padding:12px; display:flex; align-items:baseline; justify-content:space-between; gap:8px; }
.sf-card-name{ font-weight:800; font-size:1rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.sf-card-price{ font-weight:900; color:var(--sf-gold); }

/* skeleton */
.skeleton{
  position:relative; overflow:hidden;
}
.skeleton::after{
  content:''; position:absolute; inset:0;
  background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.06) 50%,rgba(255,255,255,0) 100%);
  animation:sh 1.2s infinite;
}
@keyframes sh{ 0%{ transform:translateX(-100%);} 100%{ transform:translateX(100%);} }

.sf-empty{ opacity:.8; margin-top:16px; }
      `}</style>
    </div>
  );
};

export default Shop;
